import { VFC, memo } from "react";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
} from "@chakra-ui/react";
import { useLoginUser } from "../../hooks/useLoginUser";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onClickHome: () => void;
  onClickEditTenant: () => void;
  onClickRegistTenant: () => void;
  onClickTenants: () => void;
  onClickUsers: () => void;
  onClickGroups: () => void;
  onClickLogin: () => void;
  onClickLogout: () => void;
};

export const MenuDrawer: VFC<Props> = memo((props) => {
  const loginUser = useLoginUser();

  const {
    isOpen,
    onClose,
    onClickHome,
    onClickEditTenant,
    onClickRegistTenant,
    onClickTenants,
    onClickUsers,
    onClickGroups,
    onClickLogin,
    onClickLogout,
  } = props;

  const onSelectLogin = () => {
    onClose();
    onClickLogin();
  };
  const onSelectLogout = () => {
    onClose();
    onClickLogout();
  };
  const onSelectHome = () => {
    onClose();
    onClickHome();
  };
  const onSelectUserManagement = () => {
    onClose();
    onClickEditTenant();
  };
  const onSelectRegistTenant = () => {
    onClose();
    onClickRegistTenant();
  };
  const onSelectUsers = () => {
    onClose();
    onClickUsers();
  };
  const onSelectTenants = () => {
    onClose();
    onClickTenants();
  };
  const onSelectGroups = () => {
    onClose();
    onClickGroups();
  };

  return (
    <Drawer placement='top' size="xs" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerBody as="nav" p={0} bg="gray.100">
            <Button w="100%" colorScheme='teal' borderRadius={"0px"} onClick={onSelectHome}>
              TOP
            </Button>
            <Button w="100%" onClick={onSelectUsers}>
              ユーザー管理
            </Button>
            <Button w="100%" onClick={onSelectGroups}>
              グループ管理
            </Button>
            <Button w="100%" onClick={onClickEditTenant}>
              センサー管理
            </Button>
            {
              loginUser.loginUser?.isAccountAdmin ? 
              <>
                <Button w="100%" onClick={onSelectTenants}>
                  市町村管理
                </Button>
                <Button w="100%" onClick={onSelectRegistTenant}>
                  市町村追加
                </Button>
              </>
              :
              <></>
            }
            <Button w="100%" onClick={onSelectLogout}>
              ログアウト
            </Button>
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
});
